/** Coordinate output across same-origin tabs without sharing queue or account data. */
const channel =
  typeof window !== 'undefined' && typeof BroadcastChannel !== 'undefined'
    ? new BroadcastChannel('tunes-audio-focus')
    : null
export function claimAudioFocus(): void {
  channel?.postMessage('playing')
}
export function onOtherAudioFocus(pause: () => void): () => void {
  const handle = (event: MessageEvent) => {
    if (event.data === 'playing') pause()
  }
  channel?.addEventListener('message', handle)
  return () => channel?.removeEventListener('message', handle)
}
